import {Tr, TrSpace} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ShopArtifact, ShopArtifactTarget, ShopArtifactTargetPrice, SimpleShopArtifact} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import ArtifactUtils from "@/utils/artifact-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import CreaturePanel from "@/scenes.ui/creature-panel";
// TODO УБРАТЬ ЛОДАШ И ПЕРЕДЕЛАТЬ ЖРЕТ ПАМЯТЬ
import { cloneDeep } from 'lodash';
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import SkillUtils from "@/utils/skill-utils";
import {Amount} from "@/model/amount";

export class ArtifactBuyPanel extends VerticalStandardPanel {

    private alreadyChoosenCreatures: number[] = [];
    constructor(scene: Scene, canvas: HTMLCanvasElement, sa: SimpleShopArtifact, totalPrice:Amount, alreadyChoosenCreatures:number[], initialArtifactsCount:number, unlockSumPrice:number,
                onCreatureClickCallback: (unlockSumPrice: number, chosenCreatures:number[]) => void) {
        super(scene, canvas, Tr('novaja.pokupka') + (initialArtifactsCount > 1? ' (' + (alreadyChoosenCreatures.length+1) + '/' + initialArtifactsCount +')' : ''));

        this.alreadyChoosenCreatures = alreadyChoosenCreatures;
        this.setDepth(4000);

        let nameText = TextUtils.addTextByFamily(scene, sa.name.toUpperCase(), 0, -190,
            '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_BOLD);

        let light = SpriteUtils.addSprite(this.scene, 0, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.8);
        let artIcon = SpriteUtils.addSprite(this.scene, 0, -120, sa.atlasKey, sa.imageKey, 0.8);
        scene.tweens.add({
            targets: artIcon,
            alpha: 1,
            scale: 1,
            duration: 300,
        });

        let artEffectText = TextUtils.addTextByFamily(scene, (ArtifactUtils.getEffectText(sa.effectType, sa.effectValue)!).toUpperCase(), 0, -54,
            '#e0e0e0', 13, 'normal', 450, Fonts.ARIAL_MT);

        this.add([nameText, light, artIcon, artEffectText]);


        // Если нет доступных слотов у персонажей даже для покупки (приходит пустой список с бека)
        // То показывает текст, что не слотов и все
        // Сортируем от меньшей скидке к большей - до бесплатного
        let creatures = cloneDeep(sa.targets).sort((a, b) => this.getTargetPrice(a).discount - this.getTargetPrice(b).discount);

        if (creatures.length < 1) {

            let noSlotsText = TextUtils.addTextByFamily(scene, Tr('vse.sloti.zanjati'),
                0, -10, '#fff4da', 13, 'normal', 350, Fonts.ARIAL_MT);
            this.add(noSlotsText);

        } else {

            let choseCreatureText = TextUtils.addTextByFamily(scene, Tr('viberi.kto.iz.geroev.poluchit.predmet'),
                0, -10, '#fff4da', 13, 'normal', 350, Fonts.ARIAL_MT);

            // Показываем тайтл о лучшей скидке, если ее нашли и есть хоть 1 перс с заблочеными слотами
            let countNoSlotsCreatures = sa.targets.find(t => !this.getTargetPrice(t).hasFreeSlots);
            if (countNoSlotsCreatures) {
                let discountText = TextUtils.addTextByFamily(scene, this.prepareDiscountText(sa.biggestDiscount, initialArtifactsCount), 0, 40,
                    '#99fe64', 12, 'normal', 450, Fonts.ARIAL_MT);
                this.add(discountText);
            }

            // Спавним панели существ
            // Бекенд гарантирует, что создания придут по порядку от дорого к дешевому
            for(let i = 0; i < creatures.length; i++) {

                const cellWidth = creatures.length > 2 ? 140 : 150;
                let cntr = i;
                let startX = cellWidth / 2 - creatures.length * cellWidth / 2;

                let x = startX + cntr * cellWidth;

                let creaturePanel = new CreaturePanel(this.scene!, x, 140, CreatureUtils.getCreatureById(creatures[i].creatureId),
                    () => undefined, true, true);
                creaturePanel.setHealthVisible();
                SpriteUtils.scale(creaturePanel, 0.9);

                creaturePanel.setCallback(() => {
                    if (onCreatureClickCallback != null) {
                        this.close();
                        if (this.getTargetPrice(creatures[i]).hasFreeSlots) {
                            onCreatureClickCallback(0, [...this.alreadyChoosenCreatures, creatures[i].creatureId]);
                        } else {
                            onCreatureClickCallback( this.getTargetPrice(creatures[i]).newUnlockPrice, [...this.alreadyChoosenCreatures, creatures[i].creatureId]);
                        }
                    }
                });

                this.add(creaturePanel);

                this.addDiscountInfo(x,140, creatures[i]);

            }

            this.add([choseCreatureText]);

        }

    }

    private getTargetPrice(target: ShopArtifactTarget){
        let chosenTimes = this.alreadyChoosenCreatures.filter(a => a == target.creatureId).length;
        return target.prices[chosenTimes];
    }

    private addDiscountInfo(x: number, y: number, shopTarget: ShopArtifactTarget) {

        if (!this.getTargetPrice(shopTarget).hasFreeSlots) {

            let newPriceText = TextUtils.addTextByFamily(this.scene, '' + this.getTargetPrice(shopTarget).newUnlockPrice,
                x + 3, y + 85, '#48e001', 12, 'bold', 350, Fonts.ARIAL_MT)
                .setOrigin(0, 0.5);

            let oldPriceText = TextUtils.addTextByFamily(this.scene, '' + this.getTargetPrice(shopTarget).oldUnlockPrice,
                newPriceText.getBottomLeft().x! / CU.S - 8, y + 85, '#b6b6b6', 12, 'bold', 100, Fonts.ARIAL_MT)
                .setOrigin(1, 0.5);

            let color = Phaser.Display.Color.HexStringToColor('#ffffff').color;

            let rect = this.scene.add.rectangle(oldPriceText.x, oldPriceText.y, oldPriceText.width + 5, 3, color)
                .setOrigin(1, 0.5);

            let newPriceIcon = SpriteUtils.addSprite(this.scene, newPriceText.getTopRight().x! / CU.S + 15, newPriceText.y / CU.S, Keys.IC_100_MITHRIL, undefined, 0.3);

            let openSlotText = TextUtils.addTextByFamily(this.scene, Tr('otkritie.slota'),
                x, newPriceText.y / CU.S + 20, '#bfbfbf', 10, 'normal', 350, Fonts.ARIAL_MT);


            this.add([oldPriceText, rect, newPriceText, openSlotText, newPriceIcon]);
        }
    }

    private prepareDiscountText(discount: number, initialArtifactsCount:number): string {
        if(initialArtifactsCount > 1){
            return Tr('open.slot.with.disc');
        }

        return discount >= 100 ? Tr('besplatnoe.otkritie.slota.v.podarok') : TrSpace('disc.to') + discount + Tr('pcnt.for.slot');
    }



}
